<template>
  <div class="mobilePage">
    <mxMobileVue @showWX="changeWXShow"></mxMobileVue>
    <vpnMobileVue @showWX="changeWXShow"></vpnMobileVue>
    <wxDefaultVue v-if="isWXShow" @hideWX="changeWXShow"></wxDefaultVue>
  </div>
</template>
<script>
import mxMobileVue from '@/components/mxMobile.vue'
import vpnMobileVue from '@/components/vpnMobile.vue'
import wxDefaultVue from '@/views/wxDefault';

export default {
  components: {
    mxMobileVue,
    vpnMobileVue,
    wxDefaultVue
  },
  data(){
    return {
      isWXShow: false
    }
  },
  methods: {
    changeWXShow(e){
      this.isWXShow = e
    }
  }
}
</script>
<style lang="less" scoped>
.mobilePage {
  width: 100%;
  height: 100%;
  overflow: scroll;
  background: linear-gradient(180deg, #D6EBFF 0%, #F9F9F9 81%, #FFFFFF 100%);
}
</style>